module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_MURS_BIBOND_IMPRESSION_BRIQUE.a1930c9d.png";